import * as yup from "yup"
const clientIbanFormValidations = () => {
  return yup.object().shape({
    iban: yup.string().required("IBAN is required").nullable(),
    accountTitle: yup.string().required("Account Title s required").nullable(),
    bank: yup.string().required("Bank Name is required").nullable(),
  })
}

export default clientIbanFormValidations
